module.exports = ".app-card-content {\n  padding-bottom: 16px;\n}\nmat-radio-button {\n  margin-right: 12px;\n}"